module.exports = __webpack_public_path__ + "lp/img/check_circle_green.e009b16c.svg";